import p from './user-role-bind-log.vue';

export default p;
